import { Eye } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { RichTextEditor } from "../RichTextEditor";

interface ArticlePreviewDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  summary?: string | null;
  content: string;
  // What is being previewed, e.g. "Unpublished changes" - shown above the article
  label?: string;
}

/**
 * The article as a customer reads it in the portal: title, summary panel and content, without the staff controls -
 * for checking unsaved or unpublished text before it goes live.
 */
export function ArticlePreviewDialog({ open, onOpenChange, title, summary, content, label }: ArticlePreviewDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-sm font-medium text-muted-foreground">
            <Eye className="h-4 w-4" aria-hidden="true" />
            {label ? `Preview: ${label}` : "Preview as customer"}
          </DialogTitle>
          <DialogDescription className="sr-only">How this article reads in the customer portal</DialogDescription>
        </DialogHeader>
        <article className="space-y-4">
          <h1 className="text-xl sm:text-2xl font-semibold text-foreground">{title}</h1>
          {summary && (
            <div className="p-3 sm:p-4 rounded-lg border bg-muted/40">
              <p className="text-sm sm:text-base font-medium text-foreground">{summary}</p>
            </div>
          )}
          <div className="prose prose-sm sm:prose-base max-w-none dark:prose-invert">
            <RichTextEditor content={content} onChange={() => {}} editable={false} className="border-none p-0" />
          </div>
        </article>
      </DialogContent>
    </Dialog>
  );
}
